import type { TooltipProps } from 'recharts';
import { formatNumber } from '@/lib/utils';

/** One tooltip for every chart, in the app's own colours (light and dark). */
export function ChartTooltip({ active, payload, label, format = formatNumber }: TooltipProps<number, string> & { format?: (n: number) => string }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl border border-border bg-surface-raised px-3 py-2 text-xs shadow-lg shadow-black/10">
      {label !== undefined && <p className="mb-1 font-medium text-foreground">{String(label)}</p>}
      {payload.map((p) => (
        <p key={String(p.dataKey)} className="flex items-center gap-2 text-muted-foreground">
          <span className="h-2 w-2 rounded-full" style={{ background: p.color }} aria-hidden="true" />
          {p.name}
          <span className="ml-auto pl-4 font-mono tabular-nums text-foreground">{format(Number(p.value))}</span>
        </p>
      ))}
    </div>
  );
}
